<template>
    <div class="mb-6">
        <div v-for="(group, groupIndex) in optionGroups"
            :key="group.code"
            :class="{
                'mt-4': groupIndex > 0,
            }"
        >
            <div class="mb-2 flex justify-between text-sm font-gotham">
                <label class="font-bold">
                    {{customizerStore.useTranslations(`leatherGroup_${group.group}`, group.label)}}
                </label>

                <label
                    v-if="group.containsSelected"
                    class="font-light"
                >
                    {{group.placement.selectedName}}
                </label>
            </div>

            <swatch-button-group
                :option-name="group.placement.code"
                :options="group.components"
                :selected-value="group.placement.selectedValue"
                :variant="getPlacementVariant(group.placement)"
                :hide-labels="true"
                @selection-changed="selectValue(group.placement, $event)"
            />
        </div>
    </div>
</template>

<script>
    import SwatchButtonGroup from './SwatchButtonGroup.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButtonGroup,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            /**
             * Group options according to WebTop style option groups.
             */
            optionGroups() {
                const groups = {};

                const { placement } = this;

                placement.components.forEach((component) => {
                    if (component.placeholder) {
                        return;
                    }

                    if (!this.viewController.isAvailable(component)) {
                        return;
                    }

                    const groupType = component.custom?.['fj-group'];

                    let group = groups[groupType];

                    if (group == null) {
                        group = {
                            code: `${placement.code}-${groupType}`,
                            placement,

                            groupType,
                            group: component.custom?.['fj-group'],
                            label: component.custom?.['fj-group-label'],
                            components: [],

                            containsSelected: false,
                        };

                        groups[groupType] = group;
                    }

                    if (component.code === group.placement.selectedValue) {
                        group.containsSelected = true;
                    }

                    group.components.push(component);
                });

                return Object.values(groups).filter((group) => group.components.length > 0);
            },
        },

        methods: {
            getPlacementVariant(placement) {
                return placement?.custom?.['fj-placement-variant'];
            },

            selectValue(placement, option) {
                this.customizerStore.setSelection(placement.code, option.value, false);
            },
        },
    };
</script>
